"use strict";

import _ from "lodash";

import AppConstants from "../constants/AppConstants";
import LayoutUtils from "./LayoutUtils";

class BaseLayoutTransformer {
  constructor(/** Object **/ block, /** Object **/ config = {}) {
    this.block = block;
    this.config = config;
  }

  /**
   * Gets a rectangle that represents the current size of the block for the provided layout
   * @param layout
   * @private
   */
  _getLayoutRect(/** String **/ layout) {
    let height = _.get(this.block, [layout, "h"]);
    let width = _.get(this.block, [layout, "w"]);

    return { x: 0, y: 0, w: width, h: height, x2: width, y2: height };
  }

  _shouldTransform(/** Object **/ element) {
    return (
      AppConstants.ELEMENT_TYPE_STATES != element.type &&
      AppConstants.VISIBLE_ALL == element.visible
    );
  }

  _gatherElementData(/** Array **/ blockElements, /** String **/ fromLayout) {
    let elementInfo = [];

    _.each(
      blockElements,
      _.bind(function (element, idx) {
        if (this._shouldTransform(element)) {
          let layout = _.get(element, fromLayout);

          elementInfo.push({
            id: idx,
            element: element,
            rect: LayoutUtils.getRect(layout),
            a: layout.a,
            x: layout.x,
            y: layout.y,
          });
        }
      }, this)
    );

    return elementInfo;
  }
}

export default BaseLayoutTransformer;
